import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, ToggleButton, ToggleButtonGroup, Paper, Typography } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import GeneralExpensesTab from './GeneralExpensesTab';
import CashflowTab from './CashflowTab';

const CustomLabel = ({ title }) => (
    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5, color: '#2c3e50', fontSize: '0.9rem' }}>
        {title}
    </Typography>
);

const AccountingTab = forwardRef((props, ref) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [subTab, setSubTab] = useState(searchParams.get('subtab') || 'GENERAL_EXPENSES');
    const activeTabRef = useRef();

    useImperativeHandle(ref, () => ({
        resetFilters: () => { if (activeTabRef.current?.resetFilters) activeTabRef.current.resetFilters(); },
        loadData: () => { if (activeTabRef.current?.loadData) activeTabRef.current.loadData(); },
        openExportDialog: () => { if (activeTabRef.current?.openExportDialog) activeTabRef.current.openExportDialog(); }
    }));

    const handleTabChange = (event, newValue) => {
        if (newValue) {
            setSubTab(newValue);
            const newParams = new URLSearchParams(searchParams);
            newParams.set('subtab', newValue);
            setSearchParams(newParams);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <CustomLabel title="Chế độ xem:" />
                <ToggleButtonGroup value={subTab} exclusive onChange={handleTabChange} size="small" color="primary">
                    <ToggleButton value="GENERAL_EXPENSES" sx={{ px: 3, fontWeight: 'bold' }}>
                        <ReceiptLongIcon sx={{ mr: 1 }} /> Chi phí chung
                    </ToggleButton>
                    <ToggleButton value="CASHFLOW" sx={{ px: 3, fontWeight: 'bold' }}>
                        <AccountBalanceIcon sx={{ mr: 1 }} /> Phân bổ Lợi nhuận
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Paper sx={{ pt: 2, pb: 2, px: 3, borderRadius: 2, mb: 3 }}>
                {subTab === 'GENERAL_EXPENSES' && <GeneralExpensesTab ref={activeTabRef} setCanExport={props.setCanExport} />}
                {subTab === 'CASHFLOW' && <CashflowTab ref={activeTabRef} setCanExport={props.setCanExport} />}
            </Paper>
        </Box>
    );
});

export default AccountingTab;